var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFillNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 5,
    r: 5,
    fill: "#E6570E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5003 19.3125V12.2292C20.5003 7.88 18.1912 4.23917 14.1253 3.27583V2.3125C14.1253 1.13667 13.1762 0.1875 12.0003 0.1875C10.8245 0.1875 9.87532 1.13667 9.87532 2.3125V3.27583C5.82366 4.23917 3.50033 7.86583 3.50033 12.2292V19.3125L0.666992 22.1458V23.5625H23.3337V22.1458L20.5003 19.3125ZM12.0003 27.8125C13.5587 27.8125 14.8337 26.5375 14.8337 24.9792H9.16699C9.16699 26.5375 10.442 27.8125 12.0003 27.8125ZM6.3337 20.7292H17.667V12.2292C17.667 8.71583 15.5279 5.85417 12.0004 5.85417C8.47287 5.85417 6.3337 8.71583 6.3337 12.2292V20.7292Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillNotification);
export default __webpack_public_path__ + "static/media/fill-notification.664421783ad0c756331c87e9ca563bb5.svg";
export { ForwardRef as ReactComponent };